import React, { useEffect, useState } from "react";
import goToScreen from "../lib/goToScreen";
import YotiScreen from "../Components/YotiScreen";
import Loader from "../Components/Loader";
import signOut from "../lib/signOut";
import isSiteBuilder from "../lib/isSiteBuilder";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default function EndeavourMobile({ history, location }) {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (isSiteBuilder()) {
      setTimeout(() => {
        setUrl(
          `https://endeavour.demo.yoti.com/questionnaire?sessionID=&trackingId=&token=`
        );
        setLoading(false);
      }, 2000);
      return;
    }

    const urlParams = new window.URLSearchParams(window.location.search);
    const sessionId = urlParams.get("sessionId");
    const trackingId = urlParams.get("trackingId");
    const token = urlParams.get("token");
    // const API_BASE_URL = "https://endeavour.demo.yoti.com";
    setUrl(
      `https://endeavour.demo.yoti.com/questionnaire?sessionId=${sessionId}&trackingId=${trackingId}&token=${token}`
    );
    setLoading(false);
  }, []);

  useEffect(() => {
    async function handleMessage(event) {
      if (event.data.message === "Session completed") {
        // don't need a fallback as session will only work when connected to the back-end
        return window.OrendaGetResponse(
          {
            event_name: "yoti session completed",
            data: JSON.stringify({ event_data: event.data }),
          },
          ({ current_screen }) => goToScreen(history, current_screen)
        );
      }
    }

    window.addEventListener("message", handleMessage);

    return async function cleanup() {
      window.removeEventListener("message", handleMessage);
    };
  }, [history]);

  if (loading) return <Loader />;

  return (
    <div style={{ width: "100vw", height: "90vh" }}>
      <YotiScreen url={url} signOut={() => signOut()} />
    </div>
  );
}
